import React from 'react';

const TennisMatchDescriptionTable = ({ eventDetails }) => {
  const {
    matchId, tournamentId, competition, round,
  } = eventDetails;

  return (
    <div className="table-responsive m-t-30">
      <table className="match">
        <thead className="thead--green">
          <tr>
            <th className="match__th">Match ID</th>
            <th>Round</th>
            <th>Tournament ID</th>
            <th className="match__th">Competition</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{matchId}</td>
            <td>{round}</td>
            <td>{tournamentId}</td>
            <td>{competition}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TennisMatchDescriptionTable;
